export const style = (height: number, header = true) => {
  return (numRows: number) => {
    numRows = header ? numRows + 1 : numRows;
    return { height: height * numRows + 2 };
  };
};
